import { useContext } from 'react';
import Modal from 'components/design/modal/Modal';
import styled, { css } from 'styled-components';
import { P1 } from 'components/design/text/TextComponent';
import { PrimaryButton } from 'components/design/Button';
import { useNavigate } from 'react-router';
import { StringsContext } from 'components/providers/StringsProvider/StringsContext';
import { PageRoutes } from 'components/providers/RouteProvider/RouteProvider';
import {
	removeUserFromSessionStorage,
	removeUserRoleFromSessionStorage,
} from 'utils/sessionStorage';

export const UnauthorizedModal = () => {
	const navigate = useNavigate();
	const { strings } = useContext(StringsContext);
	const { UNAUTHORIZED_ACCESS, BACK } = strings;
	return (
		<Modal onCloseModal={() => {}}>
			<StyledModalContainer>
				<StyledText>{UNAUTHORIZED_ACCESS}</StyledText>
				<StyledButtonWrapper>
					<PrimaryButton
						onClick={() => {
							navigate(PageRoutes.LOGIN, {
								state: null,
							});
							removeUserFromSessionStorage();
							removeUserRoleFromSessionStorage();
						}}
						text={BACK}
					/>
				</StyledButtonWrapper>
			</StyledModalContainer>
		</Modal>
	);
};

const StyledModalContainer = styled.div(
	({ theme: { color, breakpoints } }) => css`
		z-index: 2;
		background: ${color.modelBackgroundColor};
		text-align: center;
		margin: auto;
		color: ${color.body};
		padding: 50px;
		display: flex;
		flex-direction: column;
		width: 40%;

		${breakpoints.tabletDown} {
			width: 90%;
		}
	`
);
const StyledText = styled(P1)(
	({ theme: { color, fontSize, spacing } }) => css`
		padding: ${spacing.xxxs} ${spacing.xxxs} ${spacing.lg};
		font-size: ${fontSize._16};
		color: ${color.modelTextColor};
	`
);

const StyledButtonWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;

	button {
		border: 1px solid #ffffff;
		margin-right: 10px;
		@media (max-width: 767px) {
			padding: 8px 20px;
		}
	}
`;
